import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tenantConflictErrorTitleNonFinal: {
		id: 'eoc-changeboarding.services.use-mst-connection.tenant-conflict-error-title-non-final',
		defaultMessage: "Couldn't connect your Microsoft tenant",
		description:
			'Title of error flag shown after Teams could not be connected to JSM site due to tenant conflict.',
	},
	tenantConflictErrorDescriptionNonFinal: {
		id: 'eoc-changeboarding.services.use-mst-connection.tenant-conflict-error-description-non-final',
		defaultMessage:
			'Your Microsoft tenant is connected to a different Jira Service Management site. Disconnect your tenant from the other site or connect a different Microsoft tenant to this Jira Service Management site.',
		description:
			'Description of error flag shown after Teams could not be connected to JSM site due to tenant conflict.',
	},
	teamsLoginErrorTitleNonFinal: {
		id: 'eoc-changeboarding.services.use-mst-connection.teams-login-error-title-non-final',
		defaultMessage: "Couldn't sign in to your Microsoft account",
		description:
			'Title of error flag shown after Teams could not be connected to JSM site due to sign in issues.',
	},
	teamsLoginErrorDescriptionNonFinal: {
		id: 'eoc-changeboarding.services.use-mst-connection.teams-login-error-description-non-final',
		defaultMessage: 'Please try again or contact support for help.',
		description:
			'Description of error flag shown after Teams could not be connected to JSM site due to sign in issues.',
	},
	contactSupportBtnLabelNonFinal: {
		id: 'eoc-changeboarding.services.use-mst-connection.contact-support-btn-label-non-final',
		defaultMessage: 'Contact support',
		description: 'Button label for Contacting Support',
	},
	tenantMissmatchErrorTitleNonFinal: {
		id: 'eoc-changeboarding.services.use-mst-connection.tenant-missmatch-error-title-non-final',
		defaultMessage: "You aren't a member of the Microsoft tenant",
		description:
			'Title of error flag shown after Teams could not be connected to JSM site due to tenant mismatch.',
	},
	tenantMissmatchErrorDescriptionNonFinal: {
		id: 'eoc-changeboarding.services.use-mst-connection.tenant-missmatch-error-description-non-final',
		defaultMessage:
			"Looks like you aren't part of the Microsoft tenant you're trying to connect with Jira. Join the Microsoft tenant and try again.",
		description:
			'Description of error flag shown after Teams could not be connected to JSM site due to tenant mismatch.',
	},
});
